import ApiGetOptions from '@/datatypes/api-get-options';
import ApiService from '@/services/api/ApiService';

export default class DeletedDocumentService extends ApiService {
  public getDeletedDocuments(options) {
    return this.call(new ApiGetOptions(
      {
        url: '/deleted_documents',
        params: options,
      },
    ));
  }

  public getDeletedDocument(deletedDocumentId) {
    return this.call(new ApiGetOptions(
      {
        url: `/deleted_documents/${deletedDocumentId}`,
      },
    ));
  }

  public getDeletedDocumentCertificate(deletedDocumentId) {
    return this.call(new ApiGetOptions(
      {
        url: `/deleted_documents/${deletedDocumentId}/certificate`,
      },
    ));
  }
}
